
import React, { useState } from "react";
import "../../styles/Services.css";
import { FaMinus, FaPlus } from "react-icons/fa";
import { RiArrowRightSLine } from "react-icons/ri";
import Application_bg_img from "../../bg_images/S_app_bg_img.png";
import { useNavigate } from "react-router-dom";
import { HiArrowNarrowRight } from "react-icons/hi";



const Servicesfaqs = [
  {
    question: " What is quality assurance in the IT field? ",
    answer:
      " Quality assurance in IT focuses on ensuring that software development processes are in place to prevent defects. QA includes planning, process evaluation, testing, and continual improvement to guarantee that the final product meets the expected standards.",
  },
  {
    question: " What is qulaity assurance also known as?",
    answer:
      " Quality assurance is also known as process assurance. It is a proactive process that aims to prevent defects and improve the development process. ",
  },
  {
    question: " What is the meaning of QA in IT? ",
    answer:
      " QA in IT refers to Quality Assurance, a process used to ensure that software and systems meet certain standards and function correctly before being deployed. ",
  },
  {
    question: " What is the name for software quality assurance? ",
    answer:
      " Software quality assurance is often referred to as Software QA or Software Testing. It involves the practices and processes used to ensure the software meets specific requirements and is free from defects. ",
  },
];

const QualityAssurance = () => {
  const navigate = useNavigate();
  const [ServicesopenIndex, ServicessetOpenIndex] = useState(null); // Removed `number | null`

  const handleToggle = (index) => {
    ServicessetOpenIndex(ServicesopenIndex === index ? null : index);
  };

  return (
    <div className="Service_Container">
      {/* Cousals end */}

      <div
        className="Service_sec1"
        style={{
          backgroundImage: `url(${Application_bg_img})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "98.5vw",
        }}
      >
        <section className="Service_sec1_one">
          <h5>
            Services{" "}
            <span>
              <RiArrowRightSLine className="servrighticon" />
            </span>
            Quality Assurance
          </h5>
          <h2>Ensure Excellence with Reliable Quality Assurance</h2>
          <p>
            Ensure your software, applications, and systems meet the highest
            standards with Arshil’s comprehensive quality assurance and quality
            control services.
          </p>
          <button onClick={() => navigate("/contact")} className="S_sec1_btn1">
            Talk to the team
            <HiArrowNarrowRight className="psec1arrow" />
          </button>
        </section>
      </div>

      {/* Sec 2  */}

      <div className="Service_sec2">
        <section className="Service_sec2_in1">
          <h2>What We Offer as Part of Our Quality Assurance Services</h2>
          <section className="Service_sec2_in1_h4C">
            <section>
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img1.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Manual and Automated Testing:
                </span>{" "}
                A blend of manual and automated testing techniques to ensure
                thorough validation of your application’s functionality and
                performance.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img2.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Regression Testing:
                </span>{" "}
                We ensure that new changes or updates to your application don’t
                disrupt its existing functionality.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img3.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Performance Testing:
                </span>{" "}
                Test your application under various loads to ensure it performs
                efficiently, even under high demand.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2-img4.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Security Testing:
                </span>{" "}
                Identifying and addressing vulnerabilities to ensure your
                application is secure and protected against potential threats.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img5.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Functional Testing:
                </span>{" "}
                Testing to verify that all features and functionalities of the
                application work as expected, meeting the specified
                requirements.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img6.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Usability Testing:
                </span>{" "}
                Evaluation of your application’s user interface to ensure it is
                intuitive and user-friendly, optimizing the overall user
                experience.
              </h4>
            </section>
          </section>

          <section>
            <button
              onClick={() => navigate("/contact")}
              className="Service_sec2_in1_button"
            >
              Talk to an Team
              <HiArrowNarrowRight className="psec1arrow" />
            </button>
          </section>
        </section>

        <section>
          <img className="s_sec2_img1" src="../images/S_QA_img.png" alt="" />
        </section>
      </div>

      {/* Sec 3 */}
      <div className="Service_sec3">
        <section className="Service_sec3_one">
          <h2> Why Choose Arshil for Quality Assurance Services </h2>
          <p>
            At Arshil, we are committed to delivering flawless software that
            meets the highest quality standards. Our comprehensive Quality
            Assurance services ensure that your application is tested
            thoroughly, from functionality to security. Here's why businesses
            trust us:
          </p>
        </section>

        <section className="Service_sec3_two">
          <section className="Service_sec3_two_in1">
            <img src="../images/s_q_sec3_img1.png" alt="" />
            <h5> Improved Product Quality </h5>
          </section>
          <section className="Service_sec3_two_in1">
            <img src="../images/s_q_sec3_img2.png" alt="" />
            <h5>Risk Migigation</h5>
          </section>
          <section className="Service_sec3_two_in1">
            <img src="../images/s_q_sec3_img3.png" alt="" />
            <h5> Faster Time-to-Market</h5>
          </section>

          <section className="Service_sec3_two_in1">
            <img src="../images/s_q_sec3_img4.png" alt="" />
            <h5> Cost-Effective Solutions </h5>
          </section>
          <section className="Service_sec3_two_in1">
            <img src="../images/s_q_sec3_img5.png" alt="" />
            <h5> Automated and accurate testing processes </h5>
          </section>

          <section className="Service_sec3_two_in1">
            <img src="../images/s_q_sec3_img6.png" alt="" />
            <h5> Enchanced Customer Satisfaction </h5>
          </section>
        </section>
      </div>

      {/* sec 4  */}

      <div className="Service_sec4">
        <h1> Our Approach </h1>
        <p>
          {" "}
          We apply clear, methodical steps to ensure quality at every stage of
          the development process.
        </p>
        <ul className="Service_sec4_ul">
          <li> Define Standards and Requirements </li>
          <li>Process Evaluation</li>
          <li>Testing and Validation</li>
          <li>Continous Monitoring</li>
        </ul>
      </div>

      {/* Sec 5 */}

      <section className="Service_sec5_in1_FaQ">
        <h1 className="Service_sec5_in1_FaQ_h1">
          Frequently Asked Questions (FAQs)
        </h1>
        {Servicesfaqs.map((faq, index) => (
          <div key={index} className="Service_sec5_in1_FaQ-in1">
            <div className="faq-header" onClick={() => handleToggle(index)}>
              <h5>{faq.question}</h5>
              <span className="icon">
                {ServicesopenIndex === index ? <FaMinus /> : <FaPlus />}
              </span>
            </div>
            {ServicesopenIndex === index && (
              <p className="faq-answer">{faq.answer}</p>
            )}
          </div>
        ))}
      </section>

      <div className="Sec8_container">
        <section>
          <h1>Ready to Ensure Top-Notch Quality?</h1>
          <p>
            Get in touch with us today to discuss how our quality assurance and
            quality control solutions can help your business achieve higher
            standards and build reliable, trusted products.
          </p>
        </section>

        <section className="Sec8_container_button">
          <button onClick={() => navigate("/contact")}>
            Talk to the team
            <HiArrowNarrowRight className="psec1arrow" />
          </button>
        </section>
      </div>
    </div>
  );
};

export default QualityAssurance;



